/**
 * WAF WEB SDK 插件 - 反爬虫保护
 */
import WafSDK from '@comein/waf-web-sdk';
import { MAIN_URL_HOST } from '@/apis/host';
import { LOCAL_STORAGE_KEY } from '@/constants';
import Bridge from '@/thirdparty/scripts/bridge';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import electron, { isElectron } from '@/utils/electron';

// 匹配 localhost 或 127.0.0.1，用于判断当前是否为本机开发环境
const isLocalDevHostname = () => /^(localhost|127\.0\.0\.1)$/i.test(location.hostname);

// 非 localhost/127.0.0.1 默认开启 WafSDK，需设置 DISABLE_WAF 关闭；
// localhost/127.0.0.1 默认关闭，需设置 ENABLE_WAF 开启。
// 反调试控制页（@/pages/waf/antiDebug）复用此逻辑展示/切换开关状态。
export const isWafDefaultEnabled = () => !isLocalDevHostname();

const install = (app) => {
  try {
    const defaultEnable = isWafDefaultEnabled();

    // 非默认开启环境下 默认关闭 WafSDK 如果需要开启，需在 localStorage 中设置 ENABLE_WAF 标识符
    if (!defaultEnable && !localStorage.getItem(LOCAL_STORAGE_KEY.ENABLE_WAF)) return;

    // 默认开启环境下 默认开启 WafSDK 如果需要关闭，需在 localStorage 中设置 DISABLE_WAF 标识符
    if (defaultEnable && localStorage.getItem(LOCAL_STORAGE_KEY.DISABLE_WAF) !== null) {
      console.log('[WAF] 检测到禁用标识符，WAF 已关闭');
      return;
    }

    // 检查当前 Bridge 实例是否需要禁用 WAF
    const currentBridge = Bridge.getCurrentBridge();
    if (currentBridge && currentBridge.disableWaf) return;

    const wafInstance = new WafSDK({
      serverUrl: MAIN_URL_HOST,
      singleEntry: true,
      getUserInfo: () => {
        const userInfo = isElectron
          ? electron.sendSync('userInfo')
          : getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO);

        return {
          uid: userInfo?.uid || '',
          token: userInfo?.webtoken || ''
        };
      }
    });

    app.config.globalProperties.$waf = wafInstance;
    window.$waf = wafInstance;
    console.log('[WAF] 初始化成功');
  } catch (error) {
    console.warn('[WAF] 初始化失败', error);
  }
};

export default { install };
